import {Scene} from 'scene';

const Sprite = PIXI.Sprite;
const TextureCache = PIXI.utils.TextureCache;
const BitmapText = PIXI.extras.BitmapText;

const START_EVENT_PAGE = 1;

export default class SceneHelp extends Scene {
    constructor() {
        super();

        const infoUpUIPanel = new Sprite(TextureCache['res/info_up_panel_ui.png']);
        this.addChild(infoUpUIPanel);

        this._pageTextures = [
            TextureCache['res/info_screen.png'],
            TextureCache['res/help_info/info_event_page_000.png'],
            TextureCache['res/help_info/info_event_page_001.png'],
            TextureCache['res/help_info/info_event_page_002.png'],
            TextureCache['res/help_info/info_event_page_003.png'],
            TextureCache['res/help_info/info_event_page_004.png'],
            TextureCache['res/help_info/info_event_page_005.png'],
            TextureCache['res/help_info/info_event_page_006.png'],
            TextureCache['res/help_info/info_event_page_007.png'],
            TextureCache['res/help_info/info_event_page_008.png'],
            TextureCache['res/help_info/info_event_page_009.png'],
            TextureCache['res/help_info/info_event_page_010.png'],
            TextureCache['res/help_info/info_event_page_011.png'],
            TextureCache['res/help_info/info_event_page_012.png'],
            TextureCache['res/help_info/info_event_page_013.png'],
            TextureCache['res/help_info/info_event_page_014.png'],
            TextureCache['res/help_info/info_event_page_015.png'],
            TextureCache['res/help_info/info_event_page_016.png'],
            TextureCache['res/help_info/info_event_page_017.png'],
        ];

        this._currentPageId = 0;

        this.page = new Sprite(this._pageTextures[this._currentPageId]);
        this.page.position.set(0, 128);
        this.addChild(this.page);

        const infoDownUIPanel = new Sprite(TextureCache['res/info_down_panel_ui.png']);
        infoDownUIPanel.position.set(0, 971);
        this.addChild(infoDownUIPanel);

        this.infoTerminalLabel = new BitmapText('', {font: "terminal_red_font", align: "left"});
        this.infoTerminalLabel.position.set(1455, 61);
        infoDownUIPanel.addChild(this.infoTerminalLabel);

        this.tabRules = [];
        this.tabEvents = [];

        const tabX = [319, 810];

        for (let i = 0; i < 2; ++i) {
            let lastName = (i === 0) ? '_off' : '_on';
            let rules = new Sprite(TextureCache['res/help_info/tab_rules' + lastName + '.png']);
            rules.x = tabX[0];
            this.addChild(rules);
            this.tabRules.push(rules);

            let events = new Sprite(TextureCache['res/help_info/tab_events' + lastName + '.png']);
            events.x = tabX[1];
            this.addChild(events);
            this.tabEvents.push(events);
        }
    }

    open() {
        this.visible = true;
        this.tabEvents[1].visible = false;
        this.tabRules[1].visible = true;

        this._currentPageId = 0;
        this.page.texture = this._pageTextures[this._currentPageId];
    }

    nextPage() {
        if (this._currentPageId < this._pageTextures.length - 1) {
            this._currentPageId += 1;
            this.page.texture = this._pageTextures[this._currentPageId];

            if (this._currentPageId >= START_EVENT_PAGE) {
                this.tabEvents[1].visible = true;
                this.tabRules[1].visible = false;
            }
        }
    };

    prevPage() {
        if (this._currentPageId > 0) {
            this._currentPageId -= 1;
            this.page.texture = this._pageTextures[this._currentPageId];
            if (this._currentPageId < START_EVENT_PAGE) {
                this.tabEvents[1].visible = false;
                this.tabRules[1].visible = true;
            }
        }
    };

    isFirstPage() {
        return this._currentPageId === 0;
    }

    isLastPage() {
        return this._currentPageId === this._pageTextures.length - 1;
    }

    setTerminalId(id) {
        this.infoTerminalLabel.text = id;
    }


}


// WEBPACK FOOTER //
// ./src/help_scene.es6